export enum ProductFeatureFields {
    ID = "id",
    NAME = "name",
    DESCRIPTION = "description",
}
